<template>
    <div class="pages">

    </div>
</template>

<script>

    export default {
        name: 'singlePage',
        data() {
            return {

            }
        },
        mounted() {
            console.log(this.$route.query.id); // 访问 query 中的参数
        },
        methods: {

        }
    };
</script>

<style scoped lang="scss"></style>


// WEBPACK FOOTER //
// src/components/singlePage.vue